/* eslint-disable @typescript-eslint/camelcase */

interface PersonaInterface {
  _id: number;
  _documento: string;
  _tipo_doc: string;
  _fecha_exp: string;
  _ciudad_exp: string;
  _nombre1: string;
  _nombre2: string;
  _apellido1: string;
  _apellido2: string;
  _fecha_nac: string;
  _ciudad_nac: string;
  _genero: string;
  _estado_civil: string;
  _nivel_estudio: string;
  _personas_cargo: number;
  _tipo_vivienda: string;
  _direccion: string;
  _barrio: string;
  _telefono1: string;
  _telefono2: string;
  _correo1: string;
  _correo2: string;
}

interface PersonaDatosLabInterface {
  _id: number;
  _ocupacion: string;
  _cargo: string;
  _empresa: string;
  _telefono: string;
  _correo: string;
  _persona_contacto?: string;
  _cargo_contacto?: string;
  _salario: number;
  _duracion: number;
  _persona?: number;
}

interface PersonaDatosFamInterface {
  _id: number;
  _nombres: string;
  _apellidos: string;
  _relacion: string;
  _direccion: string;
  _telefono: string;
  _persona?: number | undefined;
}

interface PersonaDatosPerInterface {
  _id: number;
  _nombres: string;
  _apellidos: string;
  _direccion: string;
  _telefono: string;
  _correo: string;
  _persona?: number | undefined;
}

export class PersonaDatosFam implements PersonaDatosFamInterface {
  _direccion = '';
  _id = 0;
  _nombres = '';
  _apellidos = '';
  _relacion = '';
  _ocupacion = '';
  _telefono = '';
  _persona?: number | undefined;

  get id () { return this._id }
  set id (n) { this._id = n }

  get nombres () { return this._nombres }
  set nombres (n) { this._nombres = n }

  get apellidos () { return this._apellidos }
  set apellidos (n) { this._apellidos = n }

  get relacion () { return this._relacion }
  set relacion (n) { this._relacion = n }

  get telefono () { return this._telefono }
  set telefono (n) { this._telefono = n }

  get direccion () { return this._direccion }
  set direccion (n) { this._direccion = n }

  get persona () { return this._persona }
  set persona (n) { this._persona = n }

  get datos () {
    return {
      id: this.id,
      nombres: this.nombres,
      apellidos: this.apellidos,
      telefono: this.telefono,
      direccion: this.direccion,
      persona: this.persona
    }
  }
}

export class PersonaDatosLab implements PersonaDatosLabInterface {
  _ocupacion = '';
  _persona_contacto?: string | undefined;
  _cargo_contacto?: string | undefined;
  _duracion = 0;
  _id = 0;
  _cargo = '';
  _empresa = '';
  _telefono = '';
  _correo = '';
  _salario = 0;
  _persona?: number;

  get id () { return this._id }
  set id (n) { this._id = n }

  get cargo () { return this._cargo }
  set cargo (n) { this._cargo = n }

  get empresa () { return this._empresa }
  set empresa (n) { this._empresa = n }

  get telefono () { return this._telefono }
  set telefono (n) { this._telefono = n }

  get correo () { return this._correo }
  set correo (n) { this._correo = n }

  get salario () { return this._salario }
  set salario (n) { this._salario = n }

  get ocupacion () { return this._ocupacion }
  set ocupacion (n) { this._ocupacion = n }

  get duracion () { return this._duracion }
  set duracion (n) { this._duracion = n }

  get persona () { return this._persona }
  set persona (n) { this._persona = n }

  get datos () {
    return {
      id: this.id,
      cargo: this.cargo,
      empresa: this.empresa,
      telefono: this.telefono,
      correo: this.correo,
      salario: this.salario,
      ocupacion: this.ocupacion,
      duracion: this.duracion,
      persona: this.persona
    }
  }
}

export class PersonaDatosPer implements PersonaDatosPerInterface {
  _id = 0;
  _nombres = '';
  _apellidos = '';
  _direccion = '';
  _telefono = '';
  _correo = '';
  _persona?: number | undefined;

  get id () { return this._id }
  set id (n) { this._id = n }

  get nombres () { return this._nombres }
  set nombres (n) { this._nombres = n }

  get apellidos () { return this._apellidos }
  set apellidos (n) { this._apellidos = n }

  get telefono () { return this._telefono }
  set telefono (n) { this._telefono = n }

  get direccion () { return this._direccion }
  set direccion (n) { this._direccion = n }

  get correo () { return this._correo }
  set correo (n) { this._correo = n }

  get persona () { return this._persona }
  set persona (n) { this._persona = n }

  get datos () {
    return {
      id: this.id,
      nombres: this.nombres,
      apellidos: this.apellidos,
      telefono: this.telefono,
      direccion: this.direccion,
      correo: this.correo,
      persona: this.persona
    }
  }
}

export class Persona implements PersonaInterface {
  _id = 0;
  _documento = '';
  _tipo_doc = 'C.C.';
  _fecha_exp = '';
  _ciudad_exp = '';
  _nombre1 = '';
  _nombre2 = '';
  _apellido1 = '';
  _apellido2 = '';
  _fecha_nac = '';
  _ciudad_nac = '';
  _genero = '';
  _estado_civil = '';
  _nivel_estudio = '';
  _estrato = '';
  _personas_cargo = 0;
  _tipo_vivienda = '';
  _ciudad = '';
  _direccion = '';
  _barrio = '';
  _telefono1 = '';
  _telefono2 = '';
  _correo1 = '';
  _correo2 = '';
  _datosLab = [new PersonaDatosLab()]
  _datosFam = [new PersonaDatosFam(), new PersonaDatosFam()]
  _datosPer = [new PersonaDatosPer(), new PersonaDatosPer()]

  get id () { return this._id }
  set id (n) { this._id = n }

  get nroDoc () { return this._documento }
  set nroDoc (n) { this._documento = n }

  get tipoDoc () { return this._tipo_doc }
  set tipoDoc (n) { this._tipo_doc = n }

  get lugarExp () { return this._ciudad_exp }
  set lugarExp (n) { this._ciudad_exp = n }

  get fechaExp () { return this._fecha_exp }
  set fechaExp (n) { this._fecha_exp = n }

  get nombre1 () { return this._nombre1 }
  set nombre1 (n) { this._nombre1 = n }

  get nombre2 () { return this._nombre2 }
  set nombre2 (n) { this._nombre2 = n }

  get apellido1 () { return this._apellido1 }
  set apellido1 (n) { this._apellido1 = n }

  get apellido2 () { return this._apellido2 }
  set apellido2 (n) { this._apellido2 = n }

  get fechaNac () { return this._fecha_nac }
  set fechaNac (n) { this._fecha_nac = n }

  get lugarNac () { return this._ciudad_nac }
  set lugarNac (n) { this._ciudad_nac = n }

  get genero () { return this._genero }
  set genero (n) { this._genero = n }

  get estadoCivil () { return this._estado_civil }
  set estadoCivil (n) { this._estado_civil = n }

  get personasCargo () { return this._personas_cargo }
  set personasCargo (n) { this._personas_cargo = n }

  get nivelEstudio () { return this._nivel_estudio }
  set nivelEstudio (n) { this._nivel_estudio = n }

  get tipoVivienda () { return this._tipo_vivienda }
  set tipoVivienda (n) { this._tipo_vivienda = n }

  get estrato () { return this._estrato }
  set estrato (n) { this._estrato = n }

  get ciudad () { return this._ciudad }
  set ciudad (n) { this._ciudad = n }

  get barrio () { return this._barrio }
  set barrio (n) { this._barrio = n }

  get direccion () { return this._direccion }
  set direccion (n) { this._direccion = n }

  get telefono1 () { return this._telefono1 }
  set telefono1 (n) { this._telefono1 = n }

  get telefono2 () { return this._telefono2 }
  set telefono2 (n) { this._telefono2 = n }

  get correo1 () { return this._correo1 }
  set correo1 (n) { this._correo1 = n }

  get correo2 () { return this._correo2 }
  set correo2 (n) { this._correo2 = n }

  get datosFam () { return this._datosFam }
  set datosFam (n) { this._datosFam = n }

  get datosLab () { return this._datosLab }
  set datosLab (n) { this._datosLab = n }

  get datosPer () { return this._datosPer }
  set datosPer (n) { this._datosPer = n }

  get datos () {
    return {
      documento: this.nroDoc,
      tipo_doc: this.tipoDoc,
      fecha_exp: this.fechaExp,
      ciudad_exp: this.lugarExp,
      nombre1: this.nombre1,
      nombre2: this.nombre2,
      apellido1: this.apellido1,
      apellido2: this.apellido2,
      fecha_nac: this.fechaNac,
      ciudad_nac: this.lugarNac,
      genero: this.genero,
      estado_civil: this.estadoCivil,
      nivel_estudio: this.nivelEstudio,
      personas_cargo: this.personasCargo,
      tipo_vivienda: this.tipoVivienda,
      direccion: this.direccion,
      barrio: this.barrio,
      ciudad: this.ciudad,
      telefono1: this.telefono1,
      telefono2: this.telefono2,
      correo1: this.correo1,
      correo2: this.correo2,
      datosLab: this.datosLab,
      datosFam: this.datosFam,
      datosPer: this.datosPer,
      estrato: this.estrato
    }
  }
}
